<template>
  <div>
    <div class="pb-64" :style="'height:'+ (store.state.windowHeight - 180) / 2 +'px'" style="min-height:300px">
      <el-form ref="form">
        <el-space wrap>
          <el-form-item label="板块:">
            <el-select v-model="obj.selectedBlockValue" @change="handleSelectChange" style="width:120px">
              <el-option
                v-for="item in obj.selectBlockList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="多空:">
            <el-select v-model="obj.selectedDirectionValue" @change="handleSelectChange" style="width:120px">
              <el-option
                v-for="item in obj.selectDirectionList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目:">
            <el-select v-model="obj.selectedTypeValue" @change="handleSelectChange">
              <el-option
                v-for="item in obj.selectTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="期间:">  
            <el-select v-model="obj.selectedDayValue" @change="handleSelectChange" style="width:110px">
              <el-option
                v-for="item in obj.selectDayList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="">  
            <el-select v-model="obj.selectedCategoryValue" @change="handleSelectChange" style="width:100px">
              <el-option
                v-for="item in obj.selectCategoryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="排名:">   
            <el-select v-model="obj.selectedHeadTailValue" @change="handleSelectChange" style="width:80px">
              <el-option
                v-for="item in obj.selectedHeadTailList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select v-model="obj.selectedCountValue" @change="handleSelectChange" style="width:80px">
              <el-option
                v-for="item in obj.selectedCountList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="位">
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleRefresh">
              <el-icon class="el-input__icon"><refresh /></el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </el-form>
      <el-tag type="warning" size="small" v-if="obj.date!==''">数据截至到 {{ obj.date }}</el-tag>
      <div id="chart" style="width: 100%; height: 100%" ref="chartDomRef"></div>
    </div>
    <div :style="'height:'+ (store.state.windowHeight - 180) / 2 +'px'" style="min-height:300px">
      <el-table :data="obj.dataList" height="100%" :cell-style="cellStyle" @row-click="handleRowClick">
        <el-table-column fixed prop="no" label="排名" sortable/>
        <el-table-column fixed prop="name" label="名称" sortable />
        <el-table-column prop="symbol" label="代码" sortable />
        <el-table-column v-if="obj.selectedTypeValue === 'sharp'" prop="value" label="数值" sortable/>
        <el-table-column v-if="obj.selectedTypeValue !== 'sharp'" prop="value" label="数值(%)" sortable/>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { http } from '../util/http'
import { findObjByField } from '../util/base'
import { setCharts } from '../module/bar'
export default {
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      selectBlockList: [
        {
          value: 'all',
          label: '全部'
        },
        {
          value: 'gjs',
          label: '贵金属'
        },
        {
          value: 'ysjs',
          label: '有色金属'
        },
        {
          value: 'hs',
          label: '黑色'
        },
        {
          value: 'hg',
          label: '化工'
        },
        {
          value: 'ny',
          label: '能源'
        },
        {
          value: 'yzyl',
          label: '油脂油料'
        },
        {
          value: 'ncp',
          label: '农产品'
        }
      ],
      selectedBlockValue: 'all',
      selectDirectionList: [
        {
          value: 'long',
          label: '多头'
        },
        {
          value: 'short',
          label: '空头'
        }
      ],
      selectedDirectionValue: 'long',
      selectTypeList: [
        {
          value: 'rtn',
          label: '收益率(%)(对数收益率)'
        },
        {
          value: 'std',
          label: '波动率(%)'
        },
        {
          value: 'sharp',
          label: '夏普比(收益率/波动率)'
        },
        // {
        //   value: 'var',
        //   label: 'VaR(%) (95%置信区间)'
        // }
      ],
      selectedTypeValue: 'rtn',
      selectDayList: [
        {
          value: '5',
          label: '最近5日'
        },
        {
          value: '10',
          label: '最近10日'
        },
        {
          value: '20',
          label: '最近20日'
        },
        {
          value: '30',
          label: '最近30日'
        },
        {
          value: '40',
          label: '最近40日'
        },
        {
          value: '50',
          label: '最近50日'
        },
        {
          value: '60',
          label: '最近60日'
        }
      ],
      selectedDayValue: '5',
      selectCategoryList: [
        {
          value: 'mean',
          label: '均值'
        },
        {
          value: 'annualized',
          label: '年化'
        }
      ],
      selectedCategoryValue: 'mean',
      selectedHeadTailList: [
        {
          value: '1',
          label: '前'
        },
        {
          value: '-1',
          label: '后'
        },
        {
          value: '0',
          label: '前后'
        }
      ],
      selectedHeadTailValue: '1',
      selectedCountList: [
        {
          value: '3',
          label: '3'
        },
        {
          value: '5',
          label: '5'
        },
        {
          value: '10',
          label: '10'
        },
        {
          value: '20',
          label: '20'
        },
        {
          value: '50',
          label: '50'
        },
        {
          value: '100',
          label: '100'
        },
        {
          value: '0',
          label: '全部'
        }
      ],
      selectedCountValue: '0',
      dataList: [],
      date: ''
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.returnData === ''){
        // 无缓存，从后台请求数据
        requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
        // 渲染图表
        var myChart = renderChart()
        // 保存缓存(否则chart无法自适应窗口)
        setStore(myChart)
      }
    }

    // 后台获取数据
    const requestData = () => {
      let formData = new FormData()
      formData.append("block", obj.selectedBlockValue)
      formData.append("direction", obj.selectedDirectionValue)
      formData.append("category", obj.selectedTypeValue)
      formData.append("interval", obj.selectedDayValue)
      formData.append("type", obj.selectedCategoryValue)
      formData.append("sort", obj.selectedHeadTailValue)
      formData.append("limit", obj.selectedCountValue)
      http({
        url: `/return`,
        method: 'post',
        data: formData
      }).then((res) => {
        processData(res)    
        var myChart = renderChart()
        setStore(myChart)
      })
    }

    // 处理数据
    const processData = (res) => {
      // console.log(res.data)
      obj.dataList = res.data.data
      let no = 1
      obj.dataList.forEach((item) => {
        obj.date = item.date
        item.value = Number(item.value.toString().replace('%', '')) // 转换成无%的数值，便于图标显示和表格排序 toString()为了防止replace遇到数值类型报错  
        item.no = no
        no++   
      })
    }

    // 绘制图表
    const renderChart = () => {
      let Xdata = obj.dataList.map((item) => item.name)
      let Ydata = obj.dataList.map((item) => item.value)
      // console.log(Xdata)
      // console.log(Ydata)

      let title = ''
      let tempObj = findObjByField(obj.selectBlockList, 'value', obj.selectedBlockValue)
      title = tempObj.label
      tempObj = findObjByField(obj.selectDirectionList, 'value', obj.selectedDirectionValue)
      title = title + ' ' + tempObj.label
      tempObj = findObjByField(obj.selectTypeList, 'value', obj.selectedTypeValue)
      title = title + ' ' + tempObj.label
      tempObj = findObjByField(obj.selectDayList, 'value', obj.selectedDayValue)
      title = title + ' ' + tempObj.label
      tempObj = findObjByField(obj.selectCategoryList, 'value', obj.selectedCategoryValue)
      title = title + tempObj.label
      
      let tempObj2 = findObjByField(obj.selectedCountList, 'value', obj.selectedCountValue)
      if (tempObj2.label != "全部"){
        tempObj = findObjByField(obj.selectedHeadTailList, 'value', obj.selectedHeadTailValue)
        title = title + ' ' + tempObj.label
        title = title + '' + tempObj2.label + '位'
      }
      
      var myChart = setCharts(chartDomRef.value, '主力合约 ' + title, Xdata, Ydata, '45', '20%', '3%')
      return myChart
    }

    // 保存至store
    const setStore = (myChart) => {
      store.commit('setMyChart', myChart)
      var storeObj = {'selectedBlockValue': obj.selectedBlockValue,
                      'selectedDirectionValue': obj.selectedDirectionValue,
                      'selectedTypeValue': obj.selectedTypeValue,
                      'selectedDayValue': obj.selectedDayValue,
                      'selectedCategoryValue': obj.selectedCategoryValue,
                      'selectedHeadTailValue': obj.selectedHeadTailValue,
                      'selectedCountValue': obj.selectedCountValue,
                      'dataList': obj.dataList,
                      'date': obj.date}
      store.commit('setReturnData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.selectedBlockValue = store.state.returnData.selectedBlockValue
      obj.selectedDirectionValue = store.state.returnData.selectedDirectionValue
      obj.selectedTypeValue = store.state.returnData.selectedTypeValue
      obj.selectedDayValue = store.state.returnData.selectedDayValue
      obj.selectedCategoryValue = store.state.returnData.selectedCategoryValue
      obj.selectedHeadTailValue = store.state.returnData.selectedHeadTailValue
      obj.selectedCountValue = store.state.returnData.selectedCountValue
      obj.dataList = store.state.returnData.dataList
      obj.date = store.state.returnData.date
    }
    
    // 重置画面
    const resetView = () => {
      obj.selectedBlockValue = 'all'
      obj.selectedDirectionValue = 'long'
      obj.selectedTypeValue = 'rtn'
      obj.selectedDayValue = '5'
      obj.selectedCategoryValue = 'mean'
      obj.selectedHeadTailValue = '1'
      obj.selectedCountValue = '0'
      obj.dataList = []
      obj.date = ''
      requestData()
    }

    /**
     * 事件处理区域
     */

    // 按钮刷新事件
    const handleRefresh = (e) => {
      requestData()
    }

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      const name = row.name
      store.commit('setCurrentContract',name)
      router.push(`/candlestick?name=${name}`)
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row) => {
      if (row.row.value > 0 && row.columnIndex === 3) {
        return {color: 'red'}
      } else if (row.row.value < 0 && row.columnIndex === 3) {
        return {color: 'green'}
      } else {
        return {color: 'black'}
      }
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSelectChange,
      handleRefresh,
      handleRowClick,
      cellStyle
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
